export default "__VITE_ASSET__BZyN3CAr__"